// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-06-12 18:58:49 +0200 (Fri, 12 Jun 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163798 $
//  Purpose   : MODS related parts: http://www.loc.gov/standards/mods
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { loadLazy as ll } from 'uix/parts';
import log from 'uix/logging';
// ---Local imports
//~ export {Metadata, TableOfContents} from '../title'
// ---Chunked Parts
export const ModsForm = ll(()=>import(/* webpackChunkName: 'modsforms' */ '../forms/part'));
export const EditModsElementOrder = ll(()=>import(/* webpackChunkName: 'config' */ './mods_elements'));
export const ModsEditor = ll(()=>import(/* webpackChunkName: 'mods' */ './editor'));
export const ModsRawCat = ll(()=>import(/* webpackChunkName: 'mods' */ './raw_cat'));
export const ModsHist = ll(()=>import(/* webpackChunkName: 'mods' */ './history'));
export const ModsGenerate = ll(()=>import(/* webpackChunkName: 'mods' */ './generate'));
export const ModsRenderer = ll(()=>import(/* webpackChunkName: 'mods' */ './rendered_table'));
export const ModsDiff = ll(()=>import(/* webpackChunkName: 'mods' */ './diff'));
export const ModsSearch = ll(()=>import(/* webpackChunkName: 'mods' */ './search'));
